























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CloseTipIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#000000' }) readonly color?: string;
}
